<template>
  <div id="role">
    <div id="role-main">
      <div id="role-shows">
        <img
          class="shows-head"
          v-for="(item, index) in showsHead"
          :key="'head-' + index"
          :id="item"
          :src="item == activeRole ? require('../assets/images/20260915/roles/' + item + '/' + item + '-active.png') : require('../assets/images/20260915/roles/' + item + '/' + item + '.png')"
        />
        <div
          class="box"
          v-for="(item, index) in showsHead"
          :key="'box-' + index"
          :id="item + '-box'"
          @click.stop="changeRole(item); toggleVideo(false)"
        ></div>
      </div>
      <div id="role-intro">
        <div id="intro-title">
          <p id="title-big">{{ $t("role." + activeRole + ".name") }}</p>
          <p id="title-normal">{{ $t("role." + activeRole + ".name") }}</p>
          <img
            id="title-de1"
            src="../assets/images/title-de1.png"
          />
          <div id="intro-content">
            {{ $t("role." + activeRole + ".intro") }}
          </div>
        </div>
      </div>
      <img
        id="role-image"
        :src="getNewRoleImg('back', activeRole)"
      />
      <img
        id="role-bottom"
        :src="getNewRoleImg('bottom', activeRole)"
      />
      <img
        id="play"
        src="../assets/images/role-video.png"
        @click.stop="toggleVideo(true)"
      />
    </div>
    <div
      id="role-video"
      v-if="videoShow"
      @click.self="toggleVideo(false)"
    >
      <video
        id="video-main"
        :src="getVideoURL"
        autoplay
        loop
        controls
      >
        {{ $t("role.playerWarning") }}
      </video>
      <img
        id="close"
        src="../assets/images/close.png"
        @click.stop="toggleVideo(false)"
      />
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      videoShow: false,
      activeRole: "nt",
      showsHead: ["rg", "a", "hk", "hb", "nol", "kk", "ma", "es", "tk", "jn", "rc", "hzm", "bl", "nt", "ph"],
    }
  },
  methods: {
    changeRole(role) {
      this.activeRole = role
    },
    toggleVideo(bol) {
      this.videoShow = bol
    }
  },
  computed: {
    getVideoURL() {
      return 'https://bbeex.91act.com/videos/' + this.activeRole + '.mp4'
    },
    getNewRoleImg() {
      // 1. 预先定义资源上下文：指定目录、是否递归子目录、匹配图片的正则
      const roleImgContext = require.context(
        '../assets/images/20260915/roles', // 图片根目录（相对当前文件的路径）
        true, // 是否搜索子目录（这里需要，因为图片在 ${role} 子目录下）
        /\/([^/]+)\/\1-([^/]+)\.png$/ // 匹配 `${role}/${role}-${key}.png` 格式的正则
      )

      // 2. 返回接收参数的函数，通过上下文获取图片
      return (key, role) => {
        // 拼接相对上下文的路径（注意开头要加 ./）
        const imgPath = `./${role}/${role}-${key}.png`
        // 通过上下文加载图片
        return roleImgContext(imgPath)
      }
    }
    // dynamicFonts() {
    //   // ($i18n.locale, $t('role.'+activeRole+'.name'))
    //   const name = this.$t('role.'+this.activeRole+'.name')
    //   if (this.$i18n.locale == 'en') {
    //     if (name.length > 10) {
    //       return {
    //         fontSize: '4rem'
    //       }
    //     }
    //   }
    // }
  }
}
</script>

<style scoped>
#role-main {
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/role-back.png");
  background-repeat: no-repeat;
  background-size: 100%;
}

#role-shows {
  width: 700px;
  height: 712px;
  position: absolute;
  left: -130px;
  top: 50px;
  background-image: url("../assets/images/20260915/roles/bg-roles.png");
  background-repeat: no-repeat;
  background-size: 100%;
}

.shows-head {
  width: 172px;
  height: 152px;
}

#rg {
  position: absolute;
  top: 146px;
  right: 264px;
}

#rg-box {
  position: absolute;
  top: 158px;
  right: 254px;
  clip-path: polygon(4% 0%, 84% 0%, 88% 7%, 48% 85%, 40% 85%, 0% 7%);
}

#a {
  position: absolute;
  top: 163px;
  right: 173px;
}

#a-box {
  position: absolute;
  top: 156px;
  right: 184px;
  clip-path: polygon(53% 12%, 60% 12%, 100% 90%, 96% 97%, 16% 97%, 12% 90%);
}

#hk {
  position: absolute;
  top: 146px;
  right: 82px;
}

#hk-box {
  position: absolute;
  top: 158px;
  right: 72px;
  clip-path: polygon(4% 0%, 84% 0%, 88% 7%, 48% 85%, 40% 85%, 0% 7%);
}

#hb {
  position: absolute;
  top: 163px;
  right: -8px;
  z-index: 10;
}

#hb-box {
  position: absolute;
  top: 156px;
  right: 2px;
  z-index: 10;
  clip-path: polygon(53% 12%, 60% 12%, 100% 90%, 96% 97%, 16% 97%, 12% 90%);
}

#nol {
  position: absolute;
  top: 317px;
  right: 262px;
}

#nol-box {
  position: absolute;
  top: 309px;
  right: 273px;
  clip-path: polygon(53% 12%, 60% 12%, 100% 90%, 96% 97%, 16% 97%, 12% 90%);
}

#kk {
  position: absolute;
  top: 303px;
  right: 171px;
}

#kk-box {
  position: absolute;
  top: 315px;
  right: 161px;
  clip-path: polygon(4% 0%, 84% 0%, 88% 7%, 48% 85%, 40% 85%, 0% 7%);
}

#tk {
  position: absolute;
  top: 304px;
  left: 173px;
}

#tk-box {
  position: absolute;
  top: 314px;
  left: 183px;
  clip-path: polygon(4% 0%, 84% 0%, 88% 7%, 48% 85%, 40% 85%, 0% 7%);
}

#es {
  position: absolute;
  bottom: 242px;
  right: 80px;
}

#es-box {
  position: absolute;
  bottom: 250px;
  right: 91px;
  clip-path: polygon(53% 12%, 60% 12%, 100% 90%, 96% 97%, 16% 97%, 12% 90%);
}

#ma {
  position: absolute;
  top: 303px;
  right: -11px;
  z-index: 10;
}

#ma-box {
  position: absolute;
  top: 314px;
  right: -21px;
  z-index: 10;
  clip-path: polygon(4% 0%, 84% 0%, 88% 7%, 48% 85%, 40% 85%, 0% 7%);
}

#jn {
  position: absolute;
  top: -12px;
  right: 173px;
}

#jn-box {
  position: absolute;
  top: 0px;
  right: 162px;
  clip-path: polygon(4% 0%, 84% 0%, 88% 7%, 48% 85%, 40% 85%, 0% 7%);
}

#rc {
  position: absolute;
  top: 7px;
  right: 83px;
}

#rc-box {
  position: absolute;
  top: 0px;
  right: 92px;
  clip-path: polygon(53% 12%, 60% 12%, 100% 90%, 96% 97%, 16% 97%, 12% 90%);
}

#hzm {
  position: absolute;
  top: 8px;
  left: 263px;
}

#hzm-box {
  position: absolute;
  top: 0px;
  left: 250px;
  clip-path: polygon(53% 12%, 60% 12%, 100% 90%, 96% 97%, 16% 97%, 12% 90%);
}

#bl {
  position: absolute;
  top: 163px;
  left: 175px;
}

#bl-box {
  position: absolute;
  top: 156px;
  left: 163px;
  clip-path: polygon(53% 12%, 60% 12%, 100% 90%, 96% 97%, 16% 97%, 12% 90%);
}

#nt {
  position: absolute;
  top: -12px;
  left: 173px;
}

#nt-box {
  position: absolute;
  top: 0px;
  left: 183px;
  clip-path: polygon(4% 0%, 84% 0%, 88% 7%, 48% 85%, 40% 85%, 0% 7%);
}

#ph {
  position: absolute;
  bottom: 102px;
  right: 80px;
}

#ph-box {
  position: absolute;
  bottom: 90px;
  right: 70px;
  clip-path: polygon(4% 0%, 84% 0%, 88% 7%, 48% 85%, 40% 85%, 0% 7%);
}

.box {
  width: 172px;
  height: 152px;
  z-index: 99;
  /* border-radius: 65px; */
  cursor: pointer;
}

#role-intro {
  position: absolute;
  top: 40px;
  left: 560px;
  z-index: 9;
}

#intro-title {
  width: 540px;
  position: relative;
  font-weight: 800;
}

#title-big {
  font-size: 65px;
  color: transparent;
  -webkit-text-stroke: 3px #211066;

  margin: 0;
  padding: 0;
  box-sizing: border-box;
  line-height: 65px;
  padding-top: 5px;
  padding-left: 30px;

  font-family: "MiSans-Bold";
}

#title-normal {
  position: absolute;
  top: 40px;
  left: 100px;
  height: 57px;
  font-size: 52px;
  color: #fff;

  margin: 0;
  padding: 0;
  box-sizing: border-box;
  line-height: 52px;
  padding-top: 5px;

  font-family: "MiSans-Bold";
}

#title-de2 {
  width: 67px;
  height: 37px;
  display: inline-block;
  position: absolute;
  top: 53px;
  right: 35px;
}

#title-de1 {
  width: 570px;
  height: 3px;
  display: inline-block;
  position: absolute;
  top: 110px;
  right: 95px;
}

#intro-content {
  width: 300px;
  font-size: 18px;
  font-weight: 800;
  color: #adaeb5;
  margin-left: 110px;
  margin-top: 45px;

  font-family: "MiSans-Medium";
}

#role-image {
  width: 1626px;
  height: 831px;
  position: absolute;
  top: 0;
  right: -100px;
}

#role-bottom {
  width: 1920px;
  height: 403px;
  position: absolute;
  bottom: -45px;
  left: 0;
}

#play {
  width: 358px;
  height: 253px;
  position: absolute;
  right: 10px;
  bottom: 160px;
  cursor: pointer;
}

#role-video {
  width: 100%;
  height: calc(100% + 97px);
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  left: 0;
  top: -97px;
  z-index: 999;
}

#video-main {
  width: 1190px;
  height: auto;
  position: absolute;
  top: 200px;
  left: 50%;
  margin-left: -595px;
  z-index: 9999;
}

#close {
  width: 39px;
  height: 39px;
  position: absolute;
  top: 150px;
  right: 200px;
  z-index: 9999;
  cursor: pointer;
}

#role-download {
  width: 310px;
  height: auto;
  position: absolute;
  left: 0;
  bottom: 40px;
  cursor: pointer;
}
</style>
